import React from 'react'

export const InputMessage = ({ type }) => {
  return (
    <div className="cb-form-control-feedback">
      <i className="cb-icon icon-warning"></i> {`Please enter your ${type} ID`}
    </div>
  )
}

export const SuccessMessage = () => {
  return (
    <div className="cb-notification cb-notification-success">
      <i className="cb-icon icon-check_circle"></i>
      <span className="cb-notification-text">
        Your request has been submitted. If you do not receive an email within 15 minutes,
        please contact Commercial Customer Support at 800-207-0886 for further assistance.
      </span>
    </div>
  )
}

export const ErrorMessage = () => {
  return (
    <div className="cb-notification cb-notification-error">
      <i className="cb-icon icon-warning"></i>
      <span className="cb-notification-text">
        We were unable to submit your request. Please try again or contact
        Commercial Customer Support at 800-207-0886 for further assistance.
      </span>
    </div>
  )
}

export const StatusMessage = ({ status }) => {
  return (
    <div className="cb-notification cb-notification-notify" style={{ marginBottom: '10px'}}>
      <i className="cb-icon icon-warning"></i>
      <span className="cb-notification-text">
        { status }
      </span>
    </div>
  )
}